import React from 'react';
import { Location } from 'react-router';

const useTransactionId = (location: Location) => {
  const urlSearchParams = new URLSearchParams(location.search);
  return urlSearchParams.get('tid') || urlSearchParams.keys().next().value;
};

export default useTransactionId;
